export const apiBaseUri = 'https://api.p.f-365.ru';
export const app_id = process.env.APP_ID || 7942588; // 7914181 - STAGE, 7902415 - DEV, 7942588 - PROD
export const amplitude_key = '28af72f7a30d9c84cea07b382c0097f1';
export const version = 1.0;
export const isLocalDev = false;
export const access_token_test = '';
export const token_test = '';
